// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v_8L","title":"styles_title__qz8gG"};